import React from "react";
import { IPersonaSharedProps, Persona, PersonaSize, IPersonaStyles } from "@nuorder/components";
import { ASSORTMENT_PERSONA_CARD_WIDTH, COIN_SIZE, NUORDER } from "containers/folders/utils/constants";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
interface IOwnProps {
    item: nuorder.folder.v1.Permission;
}

export const PermissionNameRenderer: React.FunctionComponent<IOwnProps> = ({ item }) => {
    const personaStyles: Partial<IPersonaStyles> = React.useMemo(
        () => ({
            root: { maxWidth: ASSORTMENT_PERSONA_CARD_WIDTH, marginRight: "5vw", marginBottom: 4 },
        }),
        []
    );

    const isSupportMerchant = item?.granted_to.merchant_id === siteConfig.NUORDER_SUPPORT_MERCHANT_ID;
    const isInactive = item?.deactivated;

    const getTextWithSuffix = (text: string, isSupportMerchant: boolean, isInactive: boolean) => {
        const formattedInactive = formatMessage("(Inactive)");

        if (isSupportMerchant) {
            text = `${text} ${NUORDER}`;
        }

        if (isInactive) {
            text = `${text} ${formattedInactive}`;
        }

        return text;
    };

    const defaultPersona: IPersonaSharedProps = React.useMemo(() => {
        const text = getTextWithSuffix(item?.granted_to?.display_name, isSupportMerchant, isInactive);
        const secondaryText = getTextWithSuffix(item?.granted_to?.email, isSupportMerchant, false); // keeping isInactive false so it does not append "(Inactive)" text
        return {
            text: text,
            secondaryText: secondaryText,
            tertiaryText: "",
            optionalText: "",
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (
        <Persona
            styles={personaStyles}
            {...defaultPersona}
            coinSize={COIN_SIZE}
            size={PersonaSize.size40}
            hidePersonaDetails={false}
            imageAlt=""
        />
    );
};
